import { Typography } from "@mui/material";
import useAppFunctionalityConfig from "hooks/useAppFunctionalityConfig";
import useEstatesAndMaps from "hooks/useEstatesAndMaps";

export default function AudienceMapTitle() {
  const { isAudienceMode } = useAppFunctionalityConfig();
  const { selectedMapId, maps } = useEstatesAndMaps();
  if (!isAudienceMode) return null;
  return (
    <Typography component="h1" variant="h5" noWrap sx={{ minWidth: 0, fontWeight: 500 }}>
      {selectedMapId ? maps[selectedMapId]?.name : ""}
    </Typography>
  );
}
